import React, {useEffect} from 'react';
import {  useParams
} from "react-router-dom";
import Head from "../Head";
import RoadMap from "../Footer/RoadMap";
import "./SingleArticle.css"
import HeadCustom from "../HeadCustom";
function SingeArticle({props}) {
    const {service_id} = useParams()
     useEffect(()=>{

     },[])
        return (
            <div>
                <HeadCustom/>
                <div className="article__details">
                    <h1>{service_id}</h1>
                </div>
                <RoadMap/>
            </div>
        );

}

export default SingeArticle;